import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "iodine-padding-md search-result-details-title" }
const _hoisted_2 = { class: "iodine-padding-left-xs" }

import {useSearchStore} from 'stores/search-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultDetailsTitle',
  setup(__props) {

const searchStore = useSearchStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Book: " + _toDisplayString(_unref(searchStore).getBookTitle), 1)
  ]))
}
}

})